var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DCubeScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 121,
    viewBox: "0 0 123 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1568_13832)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6228,
    cy: 60.3755,
    rx: 18.0984,
    ry: 17.3443,
    fill: "#6EAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3441 60.3755C79.3441 69.7313 71.4253 77.3427 61.6228 77.3427C51.8203 77.3427 43.9015 69.7313 43.9015 60.3755C43.9015 51.0197 51.8203 43.4083 61.6228 43.4083C71.4253 43.4083 79.3441 51.0197 79.3441 60.3755Z",
    stroke: "black",
    strokeWidth: 0.754098
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.1668 55.6862C80.381 55.6862 79.7293 55.0345 79.7293 54.2487V50.4154C79.7293 45.4704 76.5285 42.2695 71.5835 42.2695H52.4168C47.4718 42.2695 44.271 45.4704 44.271 50.4154V54.2487C44.271 55.0345 43.6193 55.6862 42.8335 55.6862C42.0477 55.6862 41.396 55.0345 41.396 54.2487V50.4154C41.396 43.822 45.8235 39.3945 52.4168 39.3945H71.5835C78.1768 39.3945 82.6043 43.822 82.6043 50.4154V54.2487C82.6043 55.0345 81.9527 55.6862 81.1668 55.6862Z",
    fill: "#6EAEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.5835 80.6042H52.4168C45.8235 80.6042 41.396 76.1767 41.396 69.5833V65.75C41.396 64.9642 42.0477 64.3125 42.8335 64.3125C43.6193 64.3125 44.271 64.9642 44.271 65.75V69.5833C44.271 74.5283 47.4718 77.7292 52.4168 77.7292H71.5835C76.5285 77.7292 79.7293 74.5283 79.7293 69.5833V65.75C79.7293 64.9642 80.381 64.3125 81.1668 64.3125C81.9527 64.3125 82.6043 64.9642 82.6043 65.75V69.5833C82.6043 76.1767 78.1768 80.6042 71.5835 80.6042Z",
    fill: "#6EAEFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.433 52.7357L63.2264 48.8448C62.4597 48.4423 61.5588 48.4423 60.7922 48.8448L53.5855 52.7357C53.068 53.0232 52.7422 53.579 52.7422 54.2115C52.7422 54.844 53.068 55.3999 53.5855 55.6874L60.7922 59.5782C61.1755 59.7891 61.5972 59.8849 62.0188 59.8849C62.4405 59.8849 62.8622 59.7891 63.2455 59.5782L70.4522 55.6874C70.9697 55.3999 71.2955 54.844 71.2955 54.2115C71.2764 53.579 70.9505 53.0232 70.433 52.7357Z",
    fill: "#6EAEFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5851 60.9008L52.8768 57.5466C52.3593 57.2975 51.7651 57.3167 51.2668 57.6234C50.7684 57.93 50.481 58.4475 50.481 59.0225V65.3667C50.481 66.4592 51.0943 67.4559 52.0718 67.935L58.7801 71.2892C59.0101 71.4042 59.2593 71.4616 59.5276 71.4616C59.8343 71.4616 60.1218 71.385 60.3901 71.2125C60.8885 70.9058 61.176 70.3883 61.176 69.8133V63.4692C61.176 62.3767 60.5818 61.3991 59.5851 60.9008Z",
    fill: "#6EAEFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7139 57.6234C72.2155 57.3167 71.6214 57.2975 71.1039 57.5466L64.3955 60.9008C63.418 61.3991 62.8047 62.3767 62.8047 63.4692V69.8133C62.8047 70.3883 63.0922 70.9058 63.5905 71.2125C63.8589 71.385 64.1464 71.4616 64.453 71.4616C64.7022 71.4616 64.9514 71.4042 65.2005 71.2892L71.9089 67.935C72.8864 67.4367 73.4997 66.4592 73.4997 65.3667V59.0225C73.4997 58.4475 73.2122 57.93 72.7139 57.6234Z",
    fill: "#6EAEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1568_13832",
    x: 0.691628,
    y: 0.198463,
    width: 121.862,
    height: 120.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.4164,
    result: "effect1_foregroundBlur_1568_13832"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DCubeScan);
export default __webpack_public_path__ + "static/media/3d-cube-scan.d0d9fdaad714d21e92e4622edfa0de12.svg";
export { ForwardRef as ReactComponent };